<template>
  <RxkDrawer
    size="1000"
    title="审批"
    v-model="show"
    custom-class="drawer-no-header"
    :full-loading="loading"
    :footer="false"
    :close-on-click-modal="false"
    @close="close"
  >
    <template #content>
      <div class="tw-relative tw-h-full">
        <div class="flow-deal-header">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="审批信息" name="info" />
            <el-tab-pane label="审批流程" name="flow" />
          </el-tabs>
          <div class="drawer-close" @click="close">
            <span class="icon iconfont icon-close" />
          </div>
        </div>
        <div class="flow-deal-content">
          <div class="info" v-show="activeTab === 'info'">
            <div class="flow-sub-title">基本信息</div>
            <template v-if="!loading">
              <InComeDetailsLayout
                v-if="inComeCodes.includes(detail.tableCode)"
                :tableCode="detail.tableCode"
                :applyIds="inComeApplyIds"
                :permissions="detail.columnPermission || {}"
                :defaultValues="inComeValues"
                :allShow="detail.showAll"
                ref="inComeDetailsRef"
              />
              <LoanDetailsLayout
                v-else-if="loanCodes.includes(detail.tableCode)"
                :tableCode="detail.tableCode"
                :applyIds="loanApplyIds"
                :permissions="detail.columnPermission || {}"
                :formValue="loanValues"
                :allShow="detail.showAll"
                ref="loanDetailsRef"
              />
              <BillLayout
                v-else-if="billCodes.includes(detail.tableCode)"
                :tableCode="detail.tableCode"
                :id="detail.dataId"
                :permissions="detail.columnPermission || {}"
                :formValue="loanValues"
                :allShow="detail.showAll"
                :isFinish="isFinish"
                ref="billDetailsRef"
              />
              <MoneyLendingLayout
                v-else-if="moneyLendingCodes.includes(detail.tableCode)"
                :tableCode="detail.tableCode"
                :id="detail.dataId"
                :permissions="detail.columnPermission || {}"
                :formValue="loanValues"
                :allShow="detail.showAll"
                ref="moneyLendingRef"
              />
              <DetailsLayout
                v-else-if="detail.tableCode"
                :tableCode="detail.tableCode"
                :dataId="detail.dataId"
                :columnPermission="detail.columnPermission || {}"
                :columnValues="columnValues"
                :subListValues="subListValues"
                :showAll="detail.showAll"
                :deleteSublistIds="deleteSublistIds"
                :readonly="readonly"
                ref="flowContentRef"
              />
            </template>
            <div class="flow-sub-title tw-flex tw-items-center tw-justify-between">
              <span>审批详情</span>
              <el-link type="primary" @click="handleNodeEditInfo">查看节点编辑信息</el-link>
            </div>
            <FlowDetail v-if="detail?.approvalLogs" :info="detail" />
          </div>
          <div class="tw-h-full" v-show="activeTab === 'flow'">
            <div class="flow-sub-title">审批内容</div>
            <div style="height: calc(100% - 50px)">
              <FlowGraph :detail="detail" :refresh="activeTab === 'flow'" />
            </div>
          </div>
        </div>
        <div class="flow-deal-footer">
          <!--  发起人    -->
          <RxkButton
            v-if="getAuth(AuthBtn.CANCEL)"
            class="tw-ml-2"
            @click="handleEvent(AuthBtn.CANCEL)"
          >
            撤回审批
          </RxkButton>
          <el-popconfirm
            width="300"
            title="确定对该条数据重新发起审批流程？"
            @confirm="handleAgain"
            v-if="getAuth(AuthBtn.CREATE)"
          >
            <template #reference>
              <RxkButton class="tw-ml-2">重新发起</RxkButton>
            </template>
          </el-popconfirm>
          <!--   审批人    -->
          <RxkButton v-if="getAuth(AuthBtn.PASS)" type="primary" @click="handleEvent(AuthBtn.PASS)">
            通过
          </RxkButton>
          <RxkButton
            v-if="getAuth(AuthBtn.REJECT)"
            type="danger"
            class="tw-ml-2"
            @click="handleEvent(AuthBtn.REJECT)"
          >
            拒绝
          </RxkButton>
          <RxkButton
            v-if="getAuth(AuthBtn.CLOSE)"
            class="tw-ml-2"
            @click="handleEvent(AuthBtn.CLOSE)"
          >
            结束流程
          </RxkButton>
          <RxkButton
            v-if="getAuth(AuthBtn.ROLLBACK)"
            class="tw-ml-2"
            @click="handleEvent(AuthBtn.ROLLBACK)"
          >
            退回
          </RxkButton>
          <RxkButton
            v-if="getAuth(AuthBtn.TRANSFER)"
            class="tw-ml-2"
            @click="handleEvent(AuthBtn.TRANSFER)"
          >
            转交
          </RxkButton>
          <RxkButton
            v-if="getAuth(AuthBtn.ADD_SIGN)"
            class="tw-ml-2"
            @click="handleEvent(AuthBtn.ADD_SIGN)"
          >
            加签
          </RxkButton>
        </div>
        <NodeEditInfo
          v-model="showEditInfo"
          :info="detail"
          :isNoPaas="isNoPaas"
          :table-code="detail.tableCode"
        />
      </div>
      <RejectOrResolve v-model="showReject" :info="operateInfo" @submit="handleSubmit" />
      <AddSign v-model="showAddSign" @submit="handleSubmit" />
      <RollBack :list="detail?.nodeMap?.nodes" v-model="showRollBack" @submit="handleSubmit" />
      <EndFlow v-model="showEnd" @submit="handleSubmit" />
      <Revoke v-model="showRevoke" @submit="handleSubmit" />
      <TransformTo v-model="showTransfer" @submit="handleSubmit" />
      <AddForm
        v-if="addVisible"
        v-model:visible="addVisible"
        :tableCode="tableCode"
        :processGuid="processGuid"
        :form-data="defaultValue"
        :quoteDataIdList="[shopOrderId]"
        :orderType="orderType"
        :subListData="subListValues"
        :quote-table-code="quoteTableCode"
        title="重新发起"
        @addSuccess="addSuccess"
      />
    </template>
  </RxkDrawer>
</template>
<script lang="tsx" setup>
import { computed, ref, watch } from 'vue'
import { RxkDrawer } from '@/components/common/RxkDrawer'
import FlowDetail from './components/FlowDetail.vue'
import FlowGraph from './components/FlowGraph.vue'
import NodeEditInfo from './components/NodeEditInfo.vue'
import RejectOrResolve from './components/operateDialog/RejectOrResolve.vue'
import AddSign from './components/operateDialog/AddSign.vue'
import RollBack from './components/operateDialog/RollBack.vue'
import EndFlow from './components/operateDialog/EndFlow.vue'
import Revoke from './components/operateDialog/Revoke.vue'
import TransformTo from './components/operateDialog/TransformTo.vue'
import { detailsLayout as DetailsLayout } from './components/detailsLayout/index'
import { getFlowDetail, taskActionTo } from '@/apis/flow'
import { AuthBtn } from '@/components/business/FlowDeal/config'
import { useRouter } from 'vue-router'
import { AddForm } from '@/components/business/addForm'
import { router } from '@/router'
import { useGlobalStore } from '@/stores/modules/global'

import InComeDetailsLayout from './components/inComeDetailsLayout/index.vue'
import LoanDetailsLayout from './components/loanDetailsLayout/index.vue'
import BillLayout from './components/billLayout/index.vue'
import MoneyLendingLayout from './components/moneyLendingLayout/index.vue'
import { inComeCodes, loanCodes, billCodes, moneyLendingCodes } from '@/enums/flow'
import { getErpDetails } from '@/components/business/FlowDeal/utils'

interface DetailInfo {
  tableCode: string // 表单code
  dataId: string // 表单数据id
  taskGuid: string // 任务节点id
  processGuid: string // 流程id
  permissions: any[] // 按钮权限
  userRealNameMap: any // 姓名映射
  columnNameMap: any // 字段名映射
  modifyDataLogs: any[] // 修改表单数据日志
  columnPermission: any[] // 表单字段权限
  data: any // 表单数据值
  approvalLogs: any[] // 审批日志
  showAll: boolean // 是否展示全部表单数据（节点没有配置字段权限就展示全部）
  source: 'INSERT' | 'UPDATE' | 'DELETE'
  resubmitData: any
  customReq: any
  nodeMap: any
  processState: string
}

const globalStore = useGlobalStore()

const props = defineProps({
  modelValue: Boolean,
  flowId: String,
  processId: String,
  processGuid: String
})

const emits = defineEmits(['update:modelValue', 'handleUpdate'])

const show = computed({
  get: () => {
    return props.modelValue
  },
  set: val => {
    emits('update:modelValue', val)
  }
})

const detail = ref<DetailInfo>({} as DetailInfo)
const activeTab = ref('info')
const flowContentRef = ref()
const inComeDetailsRef = ref()
const loanDetailsRef = ref()
const billDetailsRef = ref()
const moneyLendingRef = ref()

watch(show, val => {
  if (val) {
    activeTab.value = 'info'
    getDetails()
  } else {
    clearCache()
  }
})

const columnValues = computed(() => {
  return detail.value?.data?.group || detail.value?.resubmitData?.group || {}
})

const inComeValues = computed(() => {
  return detail.value?.data?.customerReq || {}
})

const loanValues = computed(() => {
  return detail.value?.data?.customerReq || {}
})

const isNoPaas = computed(() => {
  return (
    inComeCodes.includes(detail.value.tableCode) ||
    loanCodes.includes(detail.value.tableCode) ||
    billCodes.includes(detail.value.tableCode) ||
    moneyLendingCodes.includes(detail.value.tableCode)
  )
})

const inComeApplyIds = reactive({
  id: '',
  productId: '',
  phone: ''
})

const loanApplyIds = computed(() => {
  return {
    id: detail.value?.dataId || ''
  }
})

const subListValues = computed(() => {
  return detail.value?.data?.sublist || detail.value?.resubmitData?.sublist || []
})

function close() {
  emits('update:modelValue', false)
}

function clearCache() {
  detail.value = {} as DetailInfo
}
const loading = ref(true)

const deleteSublistIds = ref([])
const readonly = ref(false)
const isFinish = ref(false)
async function getDetails() {
  try {
    loading.value = true
    const res: DetailInfo = await getFlowDetail({
      taskGuid: props.flowId || undefined,
      processGuid: props.processGuid || undefined,
      processId: props.processId || undefined
    })
    detail.value = formatDetail(res as DetailInfo)
    deleteSublistIds.value = res?.data?.deleteSublistIds || []
    // 有通过、结束流程按钮才可编辑
    if (!(getAuth(AuthBtn.CLOSE) || getAuth(AuthBtn.PASS))) {
      if (detail.value.columnPermission) {
        for (let key in detail.value.columnPermission) {
          detail.value.columnPermission[key] = ['READ']
          // readonly.value = true
        }
      }
    }
    // 判断流程是否结束
    const finishTypes = ['PASS', 'REJECT', 'CANCEL', 'CLOSE']
    isFinish.value = finishTypes.includes(detail.value.processState)
    // 进件参数获取
    await getIncomeApplyIds()
  } catch {
    close()
  } finally {
    loading.value = false
  }
}

function formatDetail(data: DetailInfo): DetailInfo {
  data.approvalLogs = data?.approvalLogs?.map((approval: any) => {
    if (!approval?.logs?.length && approval?.subNodeLogs?.length) {
      let logs: any = []
      let ccOperators: any = []
      approval?.subNodeLogs.forEach((sub: any) => {
        logs = logs.concat(
          sub.logs.map((el: any) => {
            return {
              ...el,
              levelName: sub.nodeName
            }
          })
        )
        ccOperators = ccOperators.concat(sub.ccOperators || [])
      })
      approval.logs = logs
      approval.ccOperators = ccOperators
    } else if (!approval?.logs?.length) {
      approval.logs = approval.operators.map((id: string) => {
        return { action: approval.processNodeState, operator: id }
      })
    }
    return approval
  })
  data.showAll = !data?.columnPermission
  return { ...data }
}

async function getIncomeApplyIds() {
  if (!inComeCodes.includes(detail.value.tableCode)) return
  let data = detail.value?.data?.customerReq
  let productId = data?.infoDTO?.productId || ''
  let phone = ''
  if (!productId) {
    const res = await getErpDetails(detail.value?.dataId)
    productId = res?.retailIntoInfoDO?.productId
    phone = res?.phone
  }
  ;(inComeApplyIds.id = detail.value?.dataId || ''), (inComeApplyIds.productId = productId || '')
  inComeApplyIds.phone = phone
}

// 审批操作
const operateInfo = ref<any>({})
const showReject = ref(false)
const showAddSign = ref(false)
const showRollBack = ref(false)
const showEnd = ref(false)
const showRevoke = ref(false)
const showTransfer = ref(false)

function getAuth(key: AuthBtn) {
  if (detail.value?.permissions?.length) {
    return detail.value.permissions?.includes(key)
  }
  return false
}

async function handleEvent(type: string) {
  let data: Recordable = {}
  if (inComeCodes.includes(detail.value.tableCode)) {
    data = await inComeDetailsRef.value?.handleSave()
  } else if (loanCodes.includes(detail.value.tableCode)) {
    data = await loanDetailsRef.value?.handleSave()
  } else if (billCodes.includes(detail.value.tableCode)) {
    data = await billDetailsRef.value?.handleSave()
  } else if (moneyLendingCodes.includes(detail.value.tableCode)) {
    data = await moneyLendingRef.value?.handleSave()
  } else {
    data = flowContentRef.value?.handleSave()
  }
  switch (type) {
    case AuthBtn.REJECT:
      operateInfo.value = { type }
      showReject.value = true
      break
    case AuthBtn.PASS:
      if (data.errorMessage) {
        ElMessage.error(data.errorMessage)
      } else {
        operateInfo.value = { type }
        showReject.value = true
      }
      break
    case AuthBtn.ADD_SIGN:
      operateInfo.value = { type }
      showAddSign.value = true
      break
    case AuthBtn.ROLLBACK:
      operateInfo.value = { type }
      showRollBack.value = true
      break
    case AuthBtn.CLOSE:
      operateInfo.value = { type }
      showEnd.value = true
      break
    case AuthBtn.CANCEL:
      operateInfo.value = { type }
      showRevoke.value = true
      break
    case AuthBtn.TRANSFER:
      operateInfo.value = { type }
      showTransfer.value = true
      break
  }
}
const { push, replace } = useRouter()
const addVisible = ref(false)
const tableCode = ref('')
const taskGuid = ref('')
const defaultValue = ref({})

function addSuccess() {
  addVisible.value = false
  emits('update:modelValue', false)
}
const quoteTableCode = ref('9c99f25a97f34da4858ea60c8adb8d') // 这里先写死后续有需求再根据对应的应用判断
const shopOrderId = ref<any>('')
const orderType = ref(0)
// 重新发起
async function handleAgain() {
  try {
    loading.value = true
    // 放款、账单、应收款审批没有重新发起，进件审批跳转到编辑页面
    if (inComeCodes.includes(detail.value.tableCode)) {
      let path =
        detail.value.tableCode === 'f455ff3085cd4bd0a1f4e5e4dd7b6344'
          ? '/incomeOrdererp'
          : '/incomeOrderbpm'
      replace(`${path}?editId=${inComeApplyIds.id}&productId=${inComeApplyIds.productId}`)
      emits('update:modelValue', false)
      // } else if (detail.value.source === 'INSERT') {
      //   // 打开新增侧拉弹框
      //   addVisible.value = true
      //   tableCode.value = detail.value.tableCode
      //   taskGuid.value = detail.value.taskGuid
      //   shopOrderId.value = detail.value?.resubmitData?.customerReq?.shopOrderId
      //   orderType.value = detail.value?.resubmitData?.customerReq?.orderType
      //   defaultValue.value = { ...unref(columnValues) }
    } else if (detail.value.source === 'UPDATE' || detail.value.source === 'INSERT') {
      const id = detail.value.dataId
      const tableCode = detail.value.tableCode
      // 如果已经在详情页会有问题
      if (router.currentRoute.value.path === '/customDetailPage') {
        replace(`/customDetailPage?id=${id}&tableCode=${tableCode}`)
      } else {
        push(`/customDetailPage?id=${id}&tableCode=${tableCode}`)
      }
      emits('update:modelValue', false)
    } else {
      await againAction()
    }
  } finally {
    loading.value = false
  }
}

async function againAction() {
  await taskActionTo({
    processGuid: detail.value.processGuid,
    action: 'RESUBMIT',
    data: undefined
  })
  ElMessage.success('重新发起成功！')
  // TODO 要不要同步更新列表
  globalStore.refresh()
  await getDetails()
}

async function handleSubmit(data: any) {
  try {
    if (data.action === AuthBtn.CLOSE && data.result === AuthBtn.PASS) {
      const temp = flowContentRef.value?.handleSave()
      if (temp?.errorMessage) {
        ElMessage.error(temp?.errorMessage)
        return false
      }
    }
    let params = {
      ...data,
      taskGuid: detail.value.taskGuid,
      modifyDataLogs: undefined,
      dataId: detail.value.dataId,
      data: undefined,
      processGuid: undefined,
      customerReq: undefined
    }
    if (data.action === AuthBtn.PASS || data.action === AuthBtn.CLOSE) {
      if (inComeCodes.includes(detail.value.tableCode)) {
        params.data = {
          customerReq: await inComeDetailsRef.value?.handleSave()
        }
        params.modifyDataLogs = await inComeDetailsRef.value?.getChangeList()
      } else if (loanCodes.includes(detail.value.tableCode)) {
        const result = await loanDetailsRef.value?.handleSave()
        params.data = {
          customerReq: result.data
        }
        params.modifyDataLogs = result.changeList
      } else if (billCodes.includes(detail.value.tableCode)) {
        const result = await billDetailsRef.value?.handleSave()
        params.data = {
          customerReq: result.data
        }
        params.modifyDataLogs = result.changeList
      } else if (moneyLendingCodes.includes(detail.value.tableCode)) {
        const result = await moneyLendingRef.value?.handleSave()
        params.data = {
          customerReq: result.data
        }
        params.modifyDataLogs = result.changeList
      } else {
        const { groups, subLists, type, changeList } = flowContentRef.value?.handleSave() || []
        params.data = { groups, subLists, type }
        params.modifyDataLogs = changeList
      }
    }
    if (data.action === AuthBtn.CANCEL) {
      params.processGuid = detail.value.processGuid
    }
    loading.value = true
    await taskActionTo(params)
    ElMessage.success('操作成功')
    await getDetails()
    emits('handleUpdate')
  } finally {
    loading.value = false
  }
}

// 节点编辑信息
const showEditInfo = ref(false)
function handleNodeEditInfo() {
  showEditInfo.value = true
}
</script>
<style lang="scss" scoped>
:deep(.el-tabs__content) {
  height: 0;
}

:deep(.el-tabs__item) {
  height: 56px;
}
:deep(.is-active) {
  font-weight: 700;
}
:deep(.el-tabs__nav-scroll) {
  padding: 0 20px;
}
:deep(.el-tabs__header) {
  margin-bottom: 0;
}
.drawer-close {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.flow-deal-header {
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}
.flow-deal-content {
  position: relative;
  padding: 62px 20px;
  height: calc(100% - 125px);
  overflow-y: auto;
  box-sizing: content-box;
  background-color: #fff;
  z-index: 0;
}
.flow-deal-footer {
  background-color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 20px;
  height: 56px;
  display: flex;
  align-items: center;
  border-top: 1px solid var(---, #ebeef5);
  z-index: 1;
}
</style>
